import { render, staticRenderFns } from "./BorrarLiquidacionModal.vue?vue&type=template&id=1028e9cb"
import script from "./BorrarLiquidacionModal.vue?vue&type=script&lang=js"
export * from "./BorrarLiquidacionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports